export default __webpack_public_path__ + "static/media/icon-bell.0dcdb324.svg";